import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";

export const contentStyles = {
  ul: { textAlign: "left" },
  p: { color: "greyscale.600" },
  px: { base: 6, md: 6, lg: 16 },
  py: 10,
  textAlign: "center",
  a: { width: "full" },
} as RichtextAdapterProps["customStyles"];
